import { Grid, InputLabel } from "@mui/material";
import { FmlxDatePicker, FmlxDropdown, FmlxLabel, FmlxTextBox } from "fmlx-common-ui";
import { Form } from "react-bootstrap";

const EssFormContent = ({ state, fields, onChange }) => {
  const handleChange = (key, value) => {
    onChange(key, value);
  };

  const renderField = (field) => {
    const {
      key,
      label,
      error,
      type = "text",
      options = [],
      disabled = false,
      inlineText,
      autoFocus,
      placeholder,
    } = field;

    const value = state?.[key] ?? "";

    if (type === "select") {
      return (
        <Form.Group fullWidth margin="dense" disabled={disabled} key={key}>
          <FmlxLabel>{label}</FmlxLabel>
          <FmlxDropdown
            items={options.map((opt) => ({
              id: opt.id,
              text: opt.label,
            }))}
            selectedItem={value}
            disabled={disabled}
            placeholder={placeholder || "Select Value"}
            onChange={(id) => handleChange(key, id)}
            separator={false}
          />
        </Form.Group>
      );
    }

    if (type === "date") {
      return (
        <Form.Group fullWidth margin="dense" disabled={disabled} key={key}>
          <FmlxLabel>{label}</FmlxLabel>
          <FmlxDatePicker
            value={value}
            variant={FmlxDatePicker.Variant.DATE}
            onChange={(e, dateValue) => handleChange(key, dateValue)}
            placeholder={placeholder}
            disabled={disabled}
            error={error}
          />
        </Form.Group>
      );
    }

    return (
      <Form.Group fullWidth margin="dense" disabled={disabled} key={key}>
        <FmlxLabel>{label}</FmlxLabel>
        <FmlxTextBox
          id={key}
          key={key}
          value={value}
          error={error}
          inlineText={inlineText}
          autoFocus={autoFocus}
          disabled={disabled}
          placeholder={placeholder}
          onChange={(e) => handleChange(key, e.value)}
        />
      </Form.Group>
    );
  };

  return (
    <Grid container spacing={2}>
      {fields.map((field, index) => (
        <Grid item
          xs={12}
          md={field.fullWidth ? 12 : 6}
          key={field.key || index}>
          {renderField(field)}
        </Grid>
      ))}
    </Grid>
  );
}
EssFormContent.propTypes = {}

EssFormContent.defaultProps = {}

export default EssFormContent;